module.exports = __webpack_public_path__ + "img/surface-other.9ce0b6d1.png";